<template>
  <div id="contact-page"  class="pageContainer">

    <div class="external-links-container">
      <div class="external-links">
        <a href="https://www.linkedin.com/in/yuri-fukuda-a17919196/" target="_blank">LinkedIn</a><br />
        <a href="https://twitter.com/airinterface" target="_blank">Twitter</a><br />
        <a href="https://www.instagram.com/airinterface.yuri/" target="_blank">Instagram - Airinterface.Yuri</a><br />
        <a href="https://www.instagram.com/emogayu/" target="_blank">Instagram - emogayu</a><br />
      </div>
    </div>

    <form class="vue-form" @submit.prevent="submit">
      <fieldset>
        <template v-if="error">
          <div class="error-message">
            <p>
              {{error}}
            </p>
          </div>
        </template>
        <div>
          <label class="label" for="name">Name</label>
          <input type="text" name="name" id="name" required="" v-model="name.value">
        </div>
        <div>
          <label class="label" for="email">Email</label>
          <input type="email" name="email" id="email" required="" :class="{ email , error: !email.valid }" v-model="email.value">
        </div>
        <div>
          <label class="label" for="textarea">Message</label>
          <textarea class="message" name="textarea" id="textarea" required="" v-model="message.text" :maxlength="message.maxlength"></textarea>
        </div>
        <div>
          <button type='submit' :disabled="loading">
            <template v-if="loading">
              Sending ...
            </template>
            <template v-else>
              Submit
            </template>
          </button>
        </div>
      </fieldset>
    </form>
    <template v-if="success">
      <div class='successMesg'>
        <p>Thank you. I'll be in touch!</p>
      </div>
    </template>

  </div>
</template>
<script>
  import gsap from "gsap";
  import Vue from 'vue'
  import FeedbackController from '@/controllers/FeedbackController.js'
  import BaseView from '@/components/BaseView'
  import Component from 'vue-class-component'
  import { VueReCaptcha } from 'vue-recaptcha-v3'
  Vue.use(VueReCaptcha, 
    { siteKey: '6Lfz4NEZAAAAAAtz3h7ZqA3QyCF1J6qcKI5FdAGu',
      loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true
      }
    });


  // https://www.w3.org/TR/html/sec-forms.html#email-state-typeemail
  const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  @Component({
      data: function() {
        return {
          name: {
            value: "",
            valid: true
          },
          email: {
            value: "",
            valid: true
          },
          message: {
            text: "",
            valid: true
          },
          recaptchaToken: null,
          error: null,
          loading: false,
          success: false
        };
      },
      methods: {
        // submit form handler
        // validate by type and value
        validate: function(type, value) {
          if (type === "email") {
            this.email.valid = this.isEmail(value) ? true : false;
          }
        },
        // check for valid email adress
        isEmail: function(value) {
          return emailRegExp.test(value);
        }

      },
      watch: {
        // watching nested property
        "email.value": function(value) {
          this.validate("email", value);
        }
      }

  })
  export default class Contact extends BaseView {
    feedbackController = null;
    endpoint = null;
    mounted(){
      this.endpoint = '/contact.php';
      this.feedbackController = new FeedbackController( this.endpoint )
      this.recaptcha();
    }

    async submit() {
      try {
        this.error = null;
        this.loading = true;
        this.data    = {
          email: this.email.value,
          name : this.name.value,
          message: this.message.text,
          token: this.recaptchaToken
        };
        const result = await this.feedbackController.postData( this.data );
        console.log( result );
        this.loading = false;
        this.success = true;
        this.processSuccess();
      } catch (error) {
        this.error = error;
        this.loading = false;
        this.success = false;
      }


    }

    processSuccess(){
      const fmEl = this.$el.querySelector('.vue-form');
      fmEl.reset();
      gsap.to( fmEl, {
        duraion: 0.75,
        scale: 0.1,
        opacity: 0,
        height: 0
      }).then( function(){
        const successEl = this.$el.querySelector('.successMesg');
        gsap.to( successEl, {
          duration: 1,
          opacity: 1
        });

      }.bind(this) );
    }

    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      this.recaptchaToken = await this.$recaptcha('contact')

      // Do stuff with the received token.
    }



  }

</script>

<style lang="scss">
  #contact-page{

    .vue-form {
      display: block;
      text-align: left;
      width: 50%;
      margin: 40px auto;
      background-color: #f4f4f442;
      font-size: 14px;
      border-radius: 5px;
      @media only screen and (max-width: 600px) {
        &{
          width: 75%
        }
      }
      fieldset{
        border: none;
      }
    }

    .vue-form div {
      position: relative;
      margin: 20px;
    }

    .vue-form h4,
    .vue-form .label {
      margin-bottom: 10px;
    }

    .vue-form .label {
      display: block;
    }

    .vue-form input,
    .vue-form textarea,
    .vue-form label {
      color: var(--basecolor);
    }

    .vue-form input[type="text"],
    .vue-form input[type="email"],
    .vue-form textarea {
      display: block;
      width: 100%;
      appearance: none;
      box-sizing: border-box;
      font-size: 14px;
      padding: 12px;
      border: 1px solid #cfd9db;
      background-color: #ffffff;
      border-radius: 0.25em;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);
      outline: var(--basecolor)
    }

    .vue-form textarea {
      min-height: 120px;
      resize: vertical;
      overflow: auto;
      font-family: "Raleway";
      font-size: 14px;
    }

    .vue-form button[type="submit"] {
      display: block;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 14px;
      width: 11em;
      height: auto;
      border: 0;
      margin: 1em auto;
      padding: 10px 30px;
      background-color: #d6d6d6;
      text-align: center;
      transition: all 0.3s ease-in-out;
      border-radius: 3px;
    }

    .vue-form button[type="submit"]:hover,
    .vue-form button[type="submit"]:focus,
    .vue-form button[type="submit"]:active {
      background-color: #c0e2ea;
      cursor: pointer;
      outline: none;
    }


    .vue-form .error-message {
      height: 40px;
      margin: 0px;
    }

    .vue-form .error-message p {
      background: #feb0bf85;
      color: #fff;
      font-weight: 600;
      font-size: 1em;
      text-align: center;
      border-radius: 4px;
      padding: 16px;
    }

    .vue-form .error {
      border-color: #e94b35 !important;
    }

    .external-links-container {
      margin-top:50px;
      width: 100%;
      line-height: 1.5em;
      left: 0px;
      text-align: center;
      @media only screen and (max-width: 600px) {
        margin-top: 20px;
      }
      .external-links {
        display:inline-block;
        width: max-content;
        text-align: left;
        a {
          display: inline-block;
          width: max-width;
          color: var(--basecolor);
        }
      }
      
    }
    .successMesg{
      width: 100%;
      text-align:center;
      font-size: 1.5em;
      opacity: 0;
    }

  }

</style>
